import { Flex, Grid, Text } from "@adobe/react-spectrum";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectAccessToken } from "store/slices/credentials";
import { Picker } from "./Picker";
import { Quiz } from "./Quiz";

export const Quizzer: FC = () => {
  const accessToken = useSelector(selectAccessToken);
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken) {
      navigate("/login");
    }
  }, [accessToken]);

  return (
    <Grid
      areas={[
        "welcome1 welcome welcome welcome welcome2",
        "buttons1 buttons buttons buttons buttons2",
        "back quiz quiz quiz forward",
      ]}
      columns={["1fr 1fr 1fr 1fr 1fr"]}
      rows={["auto", "auto", "1fr"]}
      gap="size-600"
      marginTop="size-800"
    >
      <Flex gridArea="welcome" justifyContent="space-around">
        <Text>Choose an age group:</Text>
      </Flex>
      <Picker gridArea="buttons" />
      <Quiz gridArea="quiz" />
    </Grid>
  );
};
